import { ProjectState, Layer } from "../../../shared";

export const roundEven = (x: number) => {
    let result = Math.round(x);
    while (result % 2 !== 0) {
        result -= 1;
    }
    return result;
  }
  
  export function resizeLayers(
    project: ProjectState, 
    width: number,
    height: number
) {
    const resizedLayers: Layer[] = [];
    project.layers.forEach(layer => {
        const w = roundEven(width);
        const h = roundEven(height);
        resizedLayers.push({
            ...layer,
            dimensions: {
                width: w,
                height: h
            }
        })
    });
    return resizedLayers;
  }
  